import { Modal } from 'components/Modal';
import styles from './ModalFinishOrder.module.scss';
import { Title } from 'components/Title';
import { Button } from 'ui/Button';
import { ReactComponent as IconDone } from './img/iconDone.svg';
import { ReactComponent as IconCancel } from './img/iconCancel.svg';
import { ReactComponent as IconBanner } from './img/iconBanner.svg';
import ContentLoader from 'react-content-loader';

export const ModalFinishOrder = ({
  setIsShowFinishModal,
  onConfirm,
  isLoading,
  isAll = false,
  totalAmount,
  selectedCount,
  loadindModal,
}: {
  isShowFinishModal: boolean;
  setIsShowFinishModal: (e: boolean) => void;
  onConfirm: () => void;
  isLoading: boolean;
  isAll?: boolean;
  totalAmount: number;
  selectedCount: number;
  loadindModal: boolean;
}) => {
  const handleFinishOrder = () => {
    onConfirm();
  };

  const confirmSaveCommission = async () => {
    const CONFIRMATION_WORD = 'да';
    let isConfirmed = false;

    while (!isConfirmed) {
      const enteredValue = window.prompt(
        'Сумма заказов более 200 000. Действительно хочешь завершить все заказы? Введи “да” для подтверждения!',
      );

      if (enteredValue === null) {
        return;
      }

      if (enteredValue.trim().toLowerCase() === CONFIRMATION_WORD) {
        isConfirmed = true;
      } else {
        window.alert('Неверное значение');
      }
    }

    await handleFinishOrder();
  };

  return (
    <Modal setOpen={setIsShowFinishModal}>
      {loadindModal ? (
        <ContentLoader
          speed={2}
          height={'352px'}
          width='500px'
          className={styles.tab_loader}
          backgroundColor={'#FFFFFF'}
          foregroundColor={'#D8E4FB8C'}>
          <rect x='0' y='0' rx='0' ry='0' width='100%' height='100%' />
        </ContentLoader>
      ) : (
        <div className={styles.root}>
          <Title
            className={styles.root_title}
            title={'Подтверди действие на go.skilla.ru'}
          />

          {isAll ? (
            <div className={styles.banner}>
              <div className={styles.bannerHeader}>
                <IconBanner /> {'Будут завершены все заказы'}
              </div>
              <div className={styles.bannerText}>
                {
                  'Чтобы завершить отдельные заказы, выбери их из списка и нажми "Завершить заказ".'
                }
              </div>
            </div>
          ) : (
            <div>{'Будут завершены выбранные заказы'}</div>
          )}

          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div className={styles.infoRow}>
              <p>Количество заказов:</p>
              <span>{selectedCount}</span>
            </div>

            <div className={styles.infoRow}>
              <p>На сумму:</p>
              <span>{totalAmount} ₽</span>
            </div>
          </div>
          <div className={styles.root_btn}>
            <Button
              onClick={() => setIsShowFinishModal(false)}
              theme='outline'
              className={styles.root_btn_cancel}
              size='L'>
              <IconCancel />
            </Button>
            <Button
              onClick={totalAmount >= 200000 ? confirmSaveCommission : handleFinishOrder}
              disabled={isLoading}
              className={styles.root_btn_exit}
              theme='filed'
              size='L'>
              <div>
                Завершить
                <IconDone />
              </div>
            </Button>
          </div>
        </div>
      )}
    </Modal>
  );
};
